"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sortText = exports.sortNumber = exports.sortDate = void 0;
var _lodash = _interopRequireDefault(require("lodash.isnil"));
var _getMoment = require("@shootsta/get-moment");
var _sortCompareValue = require("../constants/sortCompareValue");
var _sortTextNoValue = require("../constants/sortTextNoValue");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const getSortTextValue = value => {
  if (value) {
    return value.toLowerCase();
  }
  return _sortTextNoValue.SORT_TEXT_NO_VALUE;
};
const getSortNumberValue = value => {
  if (!(0, _lodash.default)(value)) {
    return value;
  }
  return -Infinity;
};
const getSortDateValue = value => {
  if (!value) {
    return _sortCompareValue.SORT_COMPARE_VALUE.LESSER;
  }
  return (0, _getMoment.getMoment)(value).valueOf();
};
function compare(valueA, valueB) {
  if (valueA > valueB) {
    return _sortCompareValue.SORT_COMPARE_VALUE.GREATER;
  }
  if (valueA < valueB) {
    return _sortCompareValue.SORT_COMPARE_VALUE.LESSER;
  }
  return _sortCompareValue.SORT_COMPARE_VALUE.EQUAL;
}
const sortText = (valueA, valueB) => compare(getSortTextValue(valueA), getSortTextValue(valueB));
exports.sortText = sortText;
const sortNumber = (valueA, valueB) => {
  const parsedValueA = getSortNumberValue(valueA);
  const parsedValueB = getSortNumberValue(valueB);
  if (!Number.isFinite(parsedValueA) && !Number.isFinite(parsedValueB)) {
    return _sortCompareValue.SORT_COMPARE_VALUE.EQUAL;
  }
  return compare(parsedValueA, parsedValueB);
};
exports.sortNumber = sortNumber;
const sortDate = (valueA, valueB) => compare(getSortDateValue(valueA), getSortDateValue(valueB));
exports.sortDate = sortDate;